import React, { FC, useEffect } from "react";
import { useParams } from "react-router";
import { API_URL } from "../../actions/settings";
import NotificationPopUp from "../../components/extras/NotificationPopUp";
import { IonContent } from "@ionic/react";
import Ae2Header from "../../components/AE2/Ae2Header";
import { Meter } from "../../interfaces/Meter";
import LoadingDots from "../../components/extras/LoadingDots";
import InternalMeterDataTable from "../../components/AE2/InternalMeterComponents/InternalMeterDataTable";

interface Params {
  id: string;
}

interface IProps {
}


interface MeterDataRow {
  uuid: string;
  meter: Meter;
  value: number;
  units: string;
  timestamp: string;
}
async function getData(token: string, id: string) {
  return fetch(`${API_URL}/internal_meter_data/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
        if (res.ok) {
          return res.json();
        }
        else{
            console.log('error')
            res.json().then( err => {
                NotificationPopUp("Error", err, "Could not fetch data")
            })

        }
      }).catch(error => {
        NotificationPopUp("Error", error.message, "Could not fetch data")
      });
}

const InternalMeter:FC<IProps> = (props) => {
    const { id } = useParams<Params>();
    const [data, setData] = React.useState<MeterDataRow[] | [] | null>(null);
    const [meter, setMeter] = React.useState<Meter | null>(null);

    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
      const res = await getData(token, id);
      if (res && res.status === 'success') {
        setData(res.ebo_data);
        setMeter(res.meter_data);
      }
    };
    handleData();
  }, [id]);

    return <IonContent className="main-background">
        <div>
          <Ae2Header/>
            {!meter ? 
            <LoadingDots/> : 
            <>
            <h3>{meter?.name}</h3>
            {data && data.length > 0 ? <InternalMeterDataTable data={data}/> : <p>No data available for this meter.</p> }
            </>
            }
        </div>
    </IonContent>
};

export default InternalMeter;